import { render, staticRenderFns } from "./listorder.vue?vue&type=template&id=45de98a8&scoped=true&"
import script from "./listorder.vue?vue&type=script&lang=js&"
export * from "./listorder.vue?vue&type=script&lang=js&"
import style0 from "./listorder.vue?vue&type=style&index=0&id=45de98a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45de98a8",
  null
  
)

export default component.exports